import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import { useBreadcrumbStore } from '@/store/breadCrumb'
import { pinia } from '@/config/pinia'
import { BreadcrumbItem } from '@/store/breadCrumb'

// Helper function to determine breadcrumbs from the route
function getBreadcrumbs(to: RouteLocationNormalized): BreadcrumbItem[] {
  const id = (to.params.id as string) ?? ''
  const breadcrumbs: { [key: string]: () => BreadcrumbItem[] } = {
    /*FOR ADMIN ROUTES*/
    inicio: () => [{ label: 'Inicio', route: '/home' }],
    payrollsConfig: () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Configuración de nómina', route: '/payrollsConfig' },
    ],
    'payrollsConfig/detail': () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Configuración de nómina', route: '/payrollsConfig' },
      {
        label: 'Detalles del grupo de nóminas',
        route: `/payrollsConfig/${id}`,
      },
    ],
    'payrollsConfig/add': () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Configuración de nómina', route: '/payrollsConfig' },
      { label: 'Crear grupo de nóminas', route: '/payrollsConfig/add' },
    ],
    approvalFlows: () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Configuración de nómina', route: '/payrollsConfig' },
      {
        label: 'Flujos de aprobación',
        route: `/payrollsConfig/${id}/approvalFlows`,
      },
    ],
    CreateApprovalFlow: () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Configuración de nómina', route: '/payrollsConfig' },
      {
        label: 'Flujos de aprobación',
        route: `/payrollsConfig/${id}/approvalFlows`,
      },
      {
        label: 'Crear flujo de aprobación',
        route: `/payrollsConfig/${id}/approvalFlows/add`,
      },
    ],
    ApprovalFlowDetail: () => {
      const approvalFlowId = (to.params.flowId as string) ?? ''
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Configuración de nómina', route: '/payrollsConfig' },
        {
          label: 'Flujos de aprobación',
          route: `/payrollsConfig/${id}/approvalFlows`,
        },
        {
          label: 'Detalle flujo de aprobación',
          route: `/payrollsConfig/${id}/approvalFlows/${approvalFlowId}`,
        },
      ]
    },
    documentGroups: () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Configuración de nómina', route: '/payrollsConfig' },
      {
        label: 'Grupos de documentos',
        route: `/payrollsConfig/${id}/documentGroups`,
      },
    ],
    createDocumentGroup: () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Configuración de nómina', route: '/payrollsConfig' },
      {
        label: 'Grupos de documentos',
        route: `/payrollsConfig/${id}/documentGroups`,
      },
      {
        label: 'Crear grupo de documentos',
        route: `/payrollsConfig/${id}/documentGroups/add`,
      },
    ],
    documentGroupDetail: () => {
      const documentGroupId = (to.params.documentGroupId as string) ?? ''
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Configuración de nómina', route: '/payrollsConfig' },
        {
          label: 'Grupos de documentos',
          route: `/payrollsConfig/${id}/documentGroups`,
        },
        {
          label: 'Detalle grupo de documentos',
          route: `/payrollsConfig/${id}/documentGroups/detail/${documentGroupId}`,
        },
      ]
    },
    calendarGroups: () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Configuración de nómina', route: '/payrollsConfig' },
      {
        label: 'Grupos de calendarios',
        route: `/payrollsConfig/${id}/calendarGroups`,
      },
    ],
    createCalendarGroup: () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Configuración de nómina', route: '/payrollsConfig' },
      {
        label: 'Grupos de calendarios',
        route: `/payrollsConfig/${id}/calendarGroups`,
      },
      {
        label: 'Crear grupo de calendarios',
        route: `/payrollsConfig/${id}/calendarGroups/add`,
      },
    ],
    calendarGroupDetail: () => {
      const calendarGroupId = (to.params.calendarGroupId as string) ?? ''
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Configuración de nómina', route: '/payrollsConfig' },
        {
          label: 'Grupos de calendarios',
          route: `/payrollsConfig/${id}/calendarGroups`,
        },
        {
          label: 'Detalle grupo de calendarios',
          route: `/payrollsConfig/${id}/calendarGroups/detail/${calendarGroupId}`,
        },
      ]
    },
    calendarPeriods: () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Configuración de nómina', route: '/payrollsConfig' },
      {
        label: 'Grupo de periodos de calendarios',
        route: `/payrollsConfig/${id}/calendarPeriods`,
      },
    ],
    'calendarPeriods/add': () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Configuración de nómina', route: '/payrollsConfig' },
      {
        label: 'Grupo de periodos de calendario',
        route: `/payrollsConfig/${id}/calendarPeriods`,
      },
      {
        label: 'Crear grupo de periodos de calendario',
        route: `/payrollsConfig/${id}/calendarPeriods/add`,
      },
    ],
    'calendarPeriods/detail': () => {
      const calendarPeriodId = (to.params.calendarPeriodId as string) ?? ''
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Configuración de nómina', route: '/payrollsConfig' },
        {
          label: 'Grupo de periodos de calendario',
          route: `/payrollsConfig/${id}/calendarPeriods`,
        },
        {
          label: 'Detalles de periodos de calendario',
          route: `/payrollsConfig/${id}/calendarPeriods/detail/${calendarPeriodId}`,
        },
      ]
    },
    clients: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Clientes', route: '/clients' },
      ]
    },
    'client/add': () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Clientes', route: '/clients' },
        { label: 'Crear cliente', route: '/clients/add' },
      ]
    },
    'clients/detail': () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Clientes', route: '/clients' },
        { label: 'Detalles del cliente', route: `/clients/${id}` },
      ]
    },
    companies: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Compañias', route: '/companies' },
      ]
    },
    'companiesa/add': () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Compañias', route: '/companies' },
        { label: 'Crear compañia', route: '/companies/add' },
      ]
    },
    users: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Usuarios', route: '/users' },
      ]
    },
    '/users/add': () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Usuarios', route: '/users' },
        { label: 'Crear usuario', route: '/users/add' },
      ]
    },
    'users/detail': () => {
      const username = (to.params.username as string) ?? ''
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Usuarios', route: '/users' },
        { label: 'Detalles del usuario', route: `/users/${username}` },
      ]
    },
    approvers: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Aprobadores', route: '/approvers' },
      ]
    },
    employees: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Empleados', route: '/employees' },
      ]
    },
    Reports: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Reportes', route: '/reports' },
      ]
    },
    VacationReport: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Reportes', route: '/reports' },
        { label: 'Reporte de vacaciones', route: '/reports/vacations' },
      ]
    },
    letterConfigs: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Configuraciones de cartas', route: '/letterConfigs' },
      ]
    },
    CreateLetterConfig: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Configuraciones de cartas', route: '/letterConfigs' },
        { label: 'Crear configuración de carta', route: '/letterConfigs/add' },
      ]
    },
    LetterConfigDetail: () => {
      const letterConfigId = (to.params.id as string) ?? ''
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Configuraciones de cartas', route: '/letterConfigs' },
        {
          label: 'Detalles de configuración de carta',
          route: `/letterConfigs/detail/${letterConfigId}`,
        },
      ]
    },
    CreateExternalLetters: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Configuraciones de cartas', route: '/letterConfigs' },
        { label: 'Crear carta externa', route: '/letterExternals/create' },
      ]
    },
    ExternalLetterDetail: () => {
      const externalLetterId = (to.params.id as string) ?? ''
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Configuraciones de cartas', route: '/letterConfigs' },
        {
          label: 'Detalles de cartas externa',
          route: `/letterExternals/detail/${externalLetterId}`,
        },
      ]
    },
    lettersReports: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Configuraciones de cartas', route: '/letterConfigs' },
        { label: 'Reportes de cartas', route: '/reports/letters' },
      ]
    },
    /**FOR RRHH ROUTES */
    hr: () => [
      { label: 'Inicio', route: '/home' },
      { label: 'Gestión de Empleados', route: '/hr' },
    ],
    /*FOR EMPLOYEE ROUTES*/
    profile: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Perfil', route: '/profile' },
      ]
    },
    receipts: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Recibos de nómina', route: '/receipts' },
      ]
    },
    Vacations: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Vacaciones', route: '/vacations' },
      ]
    },
    Licenses: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Licencias', route: '/licenses' },
      ]
    },
    'Documents & Policies': () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Documentos y políticas', route: '/documents&Policies' },
      ]
    },
    LetterRequests: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Cartas y constancias', route: '/letterRequests' },
      ]
    },
    /*FOR SUPERVISOR ROUTES */
    RequestHistory: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Historial de solicitudes', route: '/requestHistory' },
      ]
    },
    RequestDetail: () => {
      const requestId = (to.params.id as string) ?? ''
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Historial de solicitudes', route: '/requestHistory' },
        {
          label: 'Detalles de solicitud',
          route: `/requestDetail/${requestId}/from/${to.params.from}`,
        },
      ]
    },
    RequestApprover: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Aprobador de solicitudes', route: '/requestApprover' },
      ]
    },
    RequestApproverDetail: () => {
      const requestId = (to.params.id as string) ?? ''
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Aprobador de solicitudes', route: '/requestApprover' },
        {
          label: 'Detalles de solicitud',
          route: `/requestApprover/${requestId}`,
        },
      ]
    },
    EmployeesAsigned: () => {
      return [
        { label: 'Inicio', route: '/home' },
        { label: 'Colaboradores asignados', route: '/EmployeesAsigned' },
      ]
    },
  }

  // Return the breadcrumb if found or an empty array as fallback
  return (
    (breadcrumbs[to.name as string] && breadcrumbs[to.name as string]()) || []
  )
}

export const breadcrumbGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const breadcrumbStore = useBreadcrumbStore(pinia)
  const breadcrumbs = getBreadcrumbs(to)
  if (breadcrumbs.length) {
    breadcrumbStore.setBreadcrumb(breadcrumbs)
  } else {
    breadcrumbStore.resetBreadcrumb()
  }

  next()
}
